import script from "./MediaSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaSlider.vue?vue&type=script&setup=true&lang=js"

import "./MediaSlider.vue?vue&type=style&index=0&id=6beec7af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6beec7af"]])

export default __exports__